import { Airecommendation } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex } from "@similarweb/ui-components/foundations";

interface IProps {
    children: React.ReactNode;
}

const LeadScoreSummaryWrapper = ({ children }: IProps) => (
    <Flex
        gap="4px"
        alignItems="flex-start"
    >
        <Airecommendation
            size="xs"
            style={{ marginTop: "2px" }}
            color={colorsPalettes.carbon["200"]}
        />
        <Box
            flex="1"
            minWidth="0"
        >
            {children}
        </Box>
    </Flex>
);

export default LeadScoreSummaryWrapper;
